const buildStateColors = (stateColors, keys, baseState) => ({
  backgroundColor: stateColors[keys.background]?.color || baseState.backgroundColor,
  borderColor: stateColors[keys.border]?.color || baseState.borderColor,
  color: stateColors[keys.text]?.color || baseState.color,
})

export const buildButtonsPreviewTheme = (colors, baseTheme, config) => {
  const normalColors = colors?.types?.normal?.colors || {}
  const hoverColors = colors?.types?.hover?.colors || {}
  const disabledColors = colors?.types?.disabled?.colors || {}

  if (config.isLink) {
    return {
      ...baseTheme,
      link: {
        color: normalColors[config.normal.text]?.color || baseTheme.link.color,
        hover: hoverColors[config.hover.text]?.color || baseTheme.link.hover,
      },
    }
  }

  const baseButton = baseTheme.button[config.themeButtonKey]

  return {
    ...baseTheme,
    button: {
      ...baseTheme.button,
      [config.themeButtonKey]: {
        ...buildStateColors(normalColors, config.normal, baseButton),
        hover: buildStateColors(hoverColors, config.hover, baseButton.hover),
        disabled: buildStateColors(disabledColors, config.disabled, baseButton.disabled),
      },
    },
  }
}
